import React from "react";
//#region types
import { AsyncResultListProps } from "models/propTypes/commonPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import InputField from "../../forms/baseFields/inputField";
import ResultItemList from "../resultItemList";
import { Grid } from "@mui/material";
//#endregion
import LocalizationHelperInstance from "utils/helpers/localizationHelper";
import cssExports from "theme/styles/main.module.scss";

export const AsyncResultList: React.FC<AsyncResultListProps> = (props) => {
  const { loading } = props;

  return (
    <>
      {props.hasSearch ? (
        <InputField
          inputBaseProps={{
            placeholder:
              props.searchInputPlaceholder ??
              LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Search),
            value: `${props.searchText}`,
            onChange: props.onSearchTextChange,
          }}
          icon={IconDefinitionConstants.WSearch}
          rootClass={cssExports.searchInput}
        />
      ) : (
        <></>
      )}
      <Grid container className={cssExports.asyncResultListContainer}>
        {loading || props.items === undefined ? (
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Loading)
        ) : props.items.length === 0 ? (
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.NoResults)
        ) : (
          <ResultItemList
            items={props.items}
            onClickHandler={props.onResultItemSelect}
            selectedIds={props.selectedIds ?? []}
            onRemoveHandler={props.onResultItemRemove}
            canRemove={props.onResultItemRemove !== undefined}
            getItemTemplate={props.getItemTemplate}
          />
        )}
      </Grid>
    </>
  );
};
